module.exports = __webpack_public_path__ + "img/图片14.57ab62f4.png";